import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class ChatStoreEffects {
  constructor(private actions$: Actions) {}
} 